module.exports = __webpack_public_path__ + "a320cca859ae21ef63a23eac7e7ddbf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/20.jpg
// module id = 1347
// module chunks = 47